import { defineStore } from 'pinia'
import { ref } from 'vue'
import { deepMerge } from '@/lib/object';

/**
 * Хранилище для библиотек
 * */
export const useLibraryStore = defineStore('library', () => {
    const libraries = ref({});
    const functions = ref({});

    function addLibrary(name, library) {
        if (!libraries.value[name]) {
            libraries.value[name] = library;
            if (library?.registerRoutes) {
                library.registerRoutes();
            }
        }
    }

    /**
     * Добавляет функцию, вызываемую по коду.
     *
     * @param code - код действия
     * @param supports - функция для проверки поддерживается ли действие всегда должна возвращать boolean
     * @param action - функция для выполнения действия, всегда должна возвращать object
     * */
    function registerFunctionByCode(code, supports, action) {
        if (!functions.value[code]) {
            functions.value[code] = [];
        }
        functions.value[code][functions.value[code].length] = {
            supports,
            action
        };
    }

    /**
     * Вызывает зарегистрированные по коду функции.
     *
     * @param code - код действия
     * @param data - данные для выполнения функции
     *
     * @return object - возвращает общий объект по итогу вызова функций
     * */
    function callFunctionByCode(code, data = {}) {
        const items = functions.value[code] ?? [];
        let result = {};

        items.forEach(item => {
            if (item.supports(data)) {
                result = deepMerge(result, item.action(data));
            }
        });

        return result;
    }

    function callActionByCode(code, data = {})
    {
        Object.entries(libraries.value).forEach(([name, library]) => {
            if (library.callActionByCode) {
                library.callActionByCode(code, data);
            }
        })
    }

    return {
        addLibrary,
        callActionByCode,
        registerFunctionByCode,
        callFunctionByCode,
    }
});
